export default __webpack_public_path__ + "static/media/register.8bd0d869.svg";